import axios from 'axios'

const API_URL = "http://supportsoft.in/pizza/api";

const state = { 
   category : [],
   defaultPizzaSizes: [
       {id: 1, name: 'SMALL - 9"', price: '14.90'},
       {id: 2, name: 'LARGE - 11"', price: '17.90'},
       {id: 3, name: 'FAMILY - 13"', price: '20.90'},
   ],
   settings: []
 };
const actions = { 
    async getAllCategory({commit}) {
        let url = API_URL+'/all-category';
        await axios.get(url).then(response => {
        let catData = response.data
        commit('updateCategoryList', catData)
        })   
   },
   async getSettings({commit}){
       let url = API_URL + '/all-settings';
       await axios.get(url).then(response => {
        let settings = response.data
        commit('updateSettings', settings)
        })
   }
};
const mutations = { 
    updateCategoryList(state, payload){
        state.category = payload
    },
    updateSettings(state, payload){
        state.settings = payload;
    }
};
const getters = { 
    getAllCategory: (state) => state.category,
    getDefaultPizzaSizes: (state) => state.defaultPizzaSizes,
    settings: (state) => state.settings
};
export default {
    state,
    actions,
    mutations,
    getters
};